<template>
	<div class="p_box" id="box">
		<div id="head">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/Homet' }" replace>首页</el-breadcrumb-item>
				<el-breadcrumb-item v-if="type == 0" :to="{ path: '/Perform' }" replace>已完成</el-breadcrumb-item>
				<el-breadcrumb-item v-if="type != 0" :to="{ path: '/Analyse' }" replace>作业分析报告</el-breadcrumb-item>
				<el-breadcrumb-item>查看详情</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="p_m_t_30 content_box overflow " :style="{ height: height + 'px' }">
			<span class="type_size_22 p_flex p_m_t_30">{{name}}</span>
			<deatil-overview :ids="ids"></deatil-overview>
			<deatil-general :ids="ids"></deatil-general>
			<deatil-signal @goSignal='goSignal' :ids="ids"></deatil-signal>
		</div>
		<pop-up :show="show" :job_publish_id='job_publish_id' :id="id" @closes='closes' @goButton='goButton'></pop-up>
	</div>
</template>

<script>
import DeatilOverview from './commponents/deatiloverview.vue';
import DeatilGeneral from './commponents/deatilgeneral.vue';
import DeatilSignal from './commponents/deatilsignal.vue'
import PopUp from './commponents/popUp.vue'
export default {
	name: 'AnalyseDeatil',
	components: {
		DeatilOverview,
		DeatilGeneral,
		DeatilSignal,
		PopUp
	},
	data() {
		return {
			height: 0,
			show:false,
			type:0,
			id:0,
      		name:"",
			  ids:"",
			  job_publish_id:''
    //   item:""
		};
	},
  created(){
	//   console.log(this.$route.query.id)
	 this.ids=this.$route.query.id
	this.$request.ajax(this).post("/api_teacher/analysis_report",{
           job_publish_id: this.ids
      }).then(res=>{
        // console.log(res)
        this.name=res.data.name
      })
  },
	mounted(){
		this.indexInfo();
		this.type = this.$route.query.type
	},
	watch: {
		'$route.path': {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal == '/AnalyseDeatil') {
					var height = localStorage.getItem('height');
					if (height == '') {
					} else {
						this.height = height;
					}
				}
			}
		}
	},
	methods: {
		indexInfo() {
			// console.log(1);
			var box = document.getElementById('box').offsetHeight;
			var head = document.getElementById('head').offsetHeight;
			var height = box - head - 30;
			var heights = localStorage.getItem('height');
			if (heights == null) {
				localStorage.setItem('height', height);
			} else {
			}
			this.height = height;
		},
		goSignal(val){
			this.id=val.id
			this.job_publish_id = val.job_publish_id
			this.show = val.show
		},
		closes(val){
			this.show = val
		},
		goButton(val){
			this.show = val
		}
	},
	beforeRouteLeave(to, form, next) {
		localStorage.removeItem('height');
		next();
	}
};
</script>

<style lang="scss" scoped>
.content_box {
	background-color: #ffffff;
	padding: 0 260px;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/analyse/deatil.vue